// src/components/auth/AuthCard.jsx
import {
    XMarkIcon,
    UserCircleIcon,
    Cog6ToothIcon,
} from '@heroicons/react/24/outline';

export default function AuthCard({
    title,       // 카드 상단 제목
    children,    // 본문(폼·문구 등)
    onClose,     // X 버튼 onClick
    profile,     // true | undefined | onClick 함수
    setting,     // true | undefined | onClick 함수
    className = ""
}) {
    const hasProfile = profile !== undefined && profile !== null;
    const hasSetting = setting !== undefined && setting !== null;

    return (
        <section
            className={`
                    w-full flex flex-col bg-transparent py-3
                    md:max-w-[768px] md:rounded-xl
                    min-[769px]:shadow-lg min-[769px]:px-7
                  
                    ${className}
            `}
        >
            <header className="relative py-3">
                {title && (
                    <h1 className="text-center text-xl md:text-2xl font-semibold">
                        {title}
                    </h1>
                )}

                {/* 우측 상단 아이콘 3종 */}
                <div className="absolute right-0 top-1 flex gap-2 absolute">
                    {hasProfile && (
                        <button
                            onClick={typeof profile === 'function' ? profile : undefined}
                            aria-label="프로필"
                            className="text-gray-400 hover:text-gray-600 "
                        >
                            <UserCircleIcon className="w-7 h-7 md:w-9 md:h-9 " />
                        </button>
                    )}

                    {hasSetting && (
                        <button
                            onClick={typeof setting === 'function' ? setting : undefined}
                            aria-label="설정"
                            className="text-gray-400 hover:text-gray-600 "
                        >
                            <Cog6ToothIcon className="w-7 h-7 md:w-9 md:h-9" />
                        </button>
                    )}
                </div>
                <div className="absolute right-0 top-2">
                    {onClose && (
                        <button
                            onClick={onClose}
                            aria-label="닫기"
                            className="text-gray-400 hover:text-gray-600"
                        >
                            <XMarkIcon className="w-7 h-7 md:w-9 md:h-9 " />
                        </button>
                    )}
                </div>

            </header>

            {children}
        </section>
    );
}
